// extracted by mini-css-extract-plugin
export default {"main_sec":"style_main_sec__5RWs7","left":"style_left__Tcub-","right":"style_right__790WK","inner":"style_inner__pkOug","main-img":"style_main-img__Cb57O"};